export interface AppRelease {
    version: string;
    lastUpdate: string;
}

const stripQuotes = (value: string): string =>
    value.length >= 2 && (value.startsWith('"') || value.startsWith("'")) ? value.slice(1, -1) : value;

/**
 * Reads a `key: value` line (e.g. `version:` or `last_update:`) from the raw text of the
 * repository-root `version.txt`, which is where the app version is maintained by hand.
 * Only a line that starts with the key matches, so comments mentioning it are ignored.
 * Surrounding single or double quotes are stripped; a missing field yields ''.
 */
export const parseReleaseField = (releaseRaw: string, key: string): string => {
    const prefix = `${key}:`;
    const line = releaseRaw
        .split(/\r?\n/)
        .map(candidate => candidate.trim())
        .find(candidate => candidate.startsWith(prefix));
    return line === undefined ? '' : stripQuotes(line.substring(prefix.length).trim());
};

export const parseAppRelease = (releaseRaw: string): AppRelease => ({
    version: parseReleaseField(releaseRaw, 'version'),
    lastUpdate: parseReleaseField(releaseRaw, 'last_update'),
});

/** The release this bundle was built from; `__APP_RELEASE__` is injected by `vite.config.ts`. */
export const appRelease: AppRelease = parseAppRelease(__APP_RELEASE__);
